var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { action, makeObservable, observable } from 'mobx';
import SmartPolicy from '@data/models/SmartPolicy';
import { SmartPoliciesService } from '@data/api/services/smart-policies';
import TimeUtils from '@business/utils/time';
import { FeatureFlag, FeatureFlagManager } from '@business/feature-flags';
import Store from '../Store';
import { persistentPropertyStorage } from '../PersistentPropertyStorage';
export default class SmartPolicies {
    constructor() {
        Object.defineProperty(this, "policies", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        makeObservable(this);
    }
    get storageKey() {
        return 'smartPolicies';
    }
    add(policy) {
        this.policies[policy.id] = policy;
    }
    clear() {
        this.policies = {};
    }
    fetchPolicies() {
        return __awaiter(this, void 0, void 0, function* () {
            const property = Store.property.model;
            const smartPoliciesEnabled = property === null || property === void 0 ? void 0 : property.settings.smartPoliciesEnabled;
            const smartPolicyFeatureFlagEnabled = FeatureFlagManager.isEnabled(FeatureFlag.enableSmartPolicies);
            if (smartPolicyFeatureFlagEnabled && smartPoliciesEnabled) {
                const language = Store.environment.language;
                const { checkin } = Store.components.searchPanel.value;
                const checkinDate = checkin ? TimeUtils.format(checkin) : undefined;
                const propertyId = property === null || property === void 0 ? void 0 : property.id;
                const response = yield SmartPoliciesService.getSmartPolicies(`${propertyId}`, language, undefined, checkinDate);
                this.policies = response.policies;
                this.save();
            }
        });
    }
    load() {
        const loadedData = persistentPropertyStorage.getItem(this.storageKey);
        if (loadedData) {
            const parsedData = JSON.parse(loadedData);
            this.policies = parsedData.policies;
        }
    }
    remove(id) {
        delete this.policies[id];
    }
    save() {
        persistentPropertyStorage.setItem(this.storageKey, JSON.stringify(this));
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], SmartPolicies.prototype, "policies", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [SmartPolicy]),
    __metadata("design:returntype", void 0)
], SmartPolicies.prototype, "add", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SmartPolicies.prototype, "clear", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], SmartPolicies.prototype, "fetchPolicies", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SmartPolicies.prototype, "remove", null);
